module.exports = {
    name:      "roulette",
    buildDate: "Wed May 22 2019 12:33:25 GMT+0000 (GMT)",
    version:   "1.0.0",
    build:     "18.2348 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 11
// module chunks = 0